document.addEventListener("DOMContentLoaded", function() {
  const tabLinks = document.querySelectorAll('.lds-tabs__links a[data-tab]');

  tabLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const tabId = this.getAttribute('data-tab');

      // On récupère uniquement le bloc parent de cette section
      const section = this.closest('.lds-slideshow-list');
      if (!section) return;

      // On cible les éléments uniquement dans cette section
      const localTabLinks = section.querySelectorAll('.lds-tabs__links a[data-tab]');
      const localTabContents = section.querySelectorAll('.lds-tab__content');

      // Retire 'active' sur tous les onglets de cette section
      localTabLinks.forEach(function(tabLink) {
        tabLink.parentElement.classList.remove('active');
      });
      this.parentElement.classList.add('active');

      // Affiche uniquement le bon contenu dans cette section
      localTabContents.forEach(function(tabContent) {
        if (tabContent.getAttribute('id') === tabId) {
          tabContent.classList.add('active');
        } else {
          tabContent.classList.remove('active');
        }
      });
    });
  });

  // Scroll description inchangé
  var skipLink = document.querySelector('.skip-to-description-link');
  var targetSection = document.getElementById('TabsDescription');

  if (skipLink !== null && targetSection) {
    skipLink.addEventListener('click', function (event) {
      event.preventDefault();
      var scrollHeight = targetSection.offsetTop - 145;

      window.scrollTo({
        top: scrollHeight,
        behavior: 'smooth'
      });
    });
  }
});
